import {InferencePanel,type ModelFit} from './InferencePanel'

export type PressureEvidenceData = {
  session_id: string
  date: string | null
  n_doses: number
  n_association_blocks: number
  n_recorded_blocks: number
  n_change_blocks: number
  n_included_trials: number
  n_excluded_trials: number
  doses: Array<{
    pressure_up: number
    difficulty_up: number | null
    value: number
    n_blocks: number
    minimum_bpm: number | null
    maximum_bpm: number | null
    dispersion_status: string
  }>
  inference: ModelFit
}

const number = (value: number) => value.toLocaleString('es-AR', {maximumFractionDigits: 2})

export function PressureEvidence({evidence}: {evidence?: PressureEvidenceData}) {
  return <section className="mt-md space-y-sm" aria-label="Evidencia del efecto observado">
    <h3 className="font-semibold">Tamaño de efecto y evidencia</h3>
    <p className="text-sm">La pendiente es una magnitud no estandarizada en latidos por minuto (lpm) por 100 unidades de presión programada (UP), no una nota de regulación.</p>
    {evidence ? <>
      <p className="text-sm">{evidence.n_doses} dosis · {evidence.n_association_blocks} bloques en la asociación · {evidence.n_change_blocks}/{evidence.n_recorded_blocks} tramos con cambio HR evaluable.</p>
      <p className="text-sm">{evidence.n_included_trials} jugadas incluidas · {evidence.n_excluded_trials} excluidas. Las muestras cardíacas no cuentan como réplicas independientes.</p>
      <div className="space-y-sm">
        {evidence.doses.map((dose, i) => <div key={i} className="border-l-2 border-outline pl-md text-sm">
          <p className="font-medium">{dose.pressure_up} UP · {dose.difficulty_up ?? 'Sin dato'} UD · {dose.n_blocks} {dose.n_blocks===1 ? 'bloque' : 'bloques'}</p>
          <p>HR temprana: {number(dose.value)} lpm.</p>
          <p>{dose.minimum_bpm == null || dose.maximum_bpm == null
            ? 'Dispersión entre bloques no estimable: faltan repeticiones de esta condición.'
            : `Rango descriptivo entre medianas de bloques: ${number(dose.minimum_bpm)}–${number(dose.maximum_bpm)} lpm. No es un intervalo de confianza.`}</p>
        </div>)}
      </div>
    </> : <p className="text-sm text-text-muted">Evidencia detallada pendiente de actualizar; no se completan denominadores ni dispersión con ceros.</p>}
    {evidence ? <InferencePanel fit={evidence.inference}/> : <p className="text-sm">Falta el resultado inferencial de esta sesión; no se inventan intervalos ni p-values.</p>}
  </section>
}
